import { Injectable } from '@angular/core';
import { ListHelperService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';

export const translationsLangs = {
  en: 'languages.english',
  es: 'languages.spanish',
  fr: 'languages.french',
  de: 'languages.german',
  pt: 'languages.portuguese',
  nl: 'languages.dutch'
};

@Injectable()
export class ItineraryTranslationsListService {
  constructor(public translate: TranslateService, public listHelper: ListHelperService) {}

  getDatasource(listId, options: any = {}, translations: any[]) {
    const dataSource = new TableDatasource({
      sort: 'lang',
      columns: this.getColumns(),
      docs: [...translations],
      limit: 10,
      total: translations ? translations.length : 0,
      ...options
    });
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  getColumns() {
    const columns = [
      {
        source: 'lang',
        label: this.translate.instant('students.header.name'),
        valueParser: (value) => `${this.translate.instant(translationsLangs[value])}  (${value})`
      },
      {
        source: 'created_at',
        label: this.translate.instant('itineraries.headerTable.createdAt'),
        dataType: DataTypes.datetime,
        valueParser: (value) => this.listHelper.parseDate(value)
      },
      {
        source: 'updated_at',
        label: this.translate.instant('itineraries.headerTable.updatedAt'),
        dataType: DataTypes.datetime,
        valueParser: (value) => this.listHelper.parseDate(value)
      }
    ];
    return columns;
  }
}
